import type { Snapshot } from '../types/agreements.types';
import { readObject, readString } from './snapshotReaders';

const canonical = (registration: string): string => registration.replace(/\s+/g, '').toUpperCase();

// The quote update path keeps `formatted_vrm` when only `vrm` changes, so a formatted
// value that no longer matches the raw one is stale formatting, not a live rendering.
export const resolveRegistration = (snapshot: Snapshot): string | undefined => {
    const currentStatus = readObject(snapshot.current_status);
    const raw = readString(currentStatus?.vrm);
    const formatted = readString(currentStatus?.formatted_vrm);

    if (formatted && (!raw || canonical(formatted) === canonical(raw))) {
        return formatted;
    }

    return raw ?? readString(snapshot.vrm);
};
